import { memo } from 'react';
import { GoogleDrive, Group, SharedDrive, Recent, Star, InternalDrive, Folder } from '@clds/icon';
import { KIND } from '../../data/consts';

const TYPE_ICONS = {
  [KIND.MY_DRIVE]: GoogleDrive,
  [KIND.SHARED_WITH_ME]: Group,
  [KIND.SHARED_DRIVE]: SharedDrive,
  [KIND.RECENT]: Recent,
  [KIND.STARRED]: Star,
  [KIND.DRIVE]: InternalDrive,
};

const FolderIcon = ({ kind, variant }) => {
  const Icon = TYPE_ICONS[kind] || Folder;
  return <Icon variant={variant} />;
};

export default memo(FolderIcon);
